import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
// import { ProjectService } from '../project/project.service';
import { Validators, FormControl } from '@angular/forms';
import { fuseConfig } from 'app/fuse-config';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import * as _ from 'lodash';
import * as moment from 'moment';
import { MemberPassword } from '@fuse/types/password';
var ProfileComponent = /** @class */ (function () {
    function ProfileComponent(_authService, _profileService, _notificationsService, _formBuilder, route, _router, _uploadService, _matSnackBar, _matDialog, _translate, _translationLoader, dateAdapter) {
        this._authService = _authService;
        this._profileService = _profileService;
        this._notificationsService = _notificationsService;
        this._formBuilder = _formBuilder;
        this.route = route;
        this._router = _router;
        this._uploadService = _uploadService;
        this._matSnackBar = _matSnackBar;
        this._matDialog = _matDialog;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.dateAdapter = dateAdapter;
        this.loggedIn = false;
        this.signedInAlready = false;
        this.showSignInButton = false;
        this.projectsData = [];
        this.profileDemogs = [];
        this.docFiles = [];
        this.checkboxErrors = {};
        this.gdprFlag = 0;
        this.maxDate = new Date().toISOString().slice(0, 10);
        this.activeTabIndex = 0;
        this.passwordDataNoEdit = true;
        this.basicDataNoEdit = true;
        this.additionalDataNoEdit = true;
        this.unreadedNotifications = '';
        this.filterCountry = [];
        this.filterCity = [];
        this.filterEmploy = [];
        this.filterPosition = [];
        this.lang = localStorage.getItem('lang') || 'sr';
        this.categories = [6, 14, 15, 16, 17, 18];
        this.defaultFilters = {};
        this.skillGroups = [];
        this.allSkills = {};
        this.memberSkills = {};
        this.genderData = [];
        this.languageData = [];
        this.levelData = [];
        this.levelDataObj = {};
        this.customDemogDataChild = [];
        this.customDemogDataLang = [];
        this.customDemogDataExperience = [];
        this.customDemogDataEducation = [];
        this.declaredSiteIdSelected = '';
        this.residenceSiteIdSelected = '';
        // Set the defaults
        this._unsubscribeAll = new Subject();
        this._fuseConfig = fuseConfig;
        this.matcher = new MyErrorStateMatcher();
        this.memberPassword = new MemberPassword({});
        this.memberPasswordForm = this.createPasswordForm();
        this.memberFirstPasswordForm = this.createFirstPasswordForm();
        this.dateAdapter.setLocale('en-gb');
    }
    ProfileComponent.prototype.createImageFromBlob = function (image) {
        var _this = this;
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            _this.profileImage = reader.result;
        }, false);
        if (image) {
            reader.readAsDataURL(image);
        }
    };
    ProfileComponent.prototype.createPasswordForm = function () {
        return this._formBuilder.group({
            password: [this.memberPassword.password, [PasswordValidation.WeakPassword]],
            confirmPassword: [''],
            oldPassword: [this.memberPassword.oldPassword]
        }, { validator: [this.checkPasswords] });
    };
    ProfileComponent.prototype.createFirstPasswordForm = function () {
        return this._formBuilder.group({
            password: [this.memberPassword.password, [PasswordValidation.WeakPassword]],
            confirmPassword: ['']
        }, { validator: [this.checkPasswords] });
    };
    ProfileComponent.prototype.checkPasswords = function (group) {
        var pass = group.get('password').value;
        var confirmPass = group.get('confirmPassword').value;
        return pass === confirmPass ? null : { notSame: true };
    };
    ProfileComponent.prototype.createBasicProfileForm = function () {
        console.log(this.profileData.date_of_birth);
        console.log(this.dateLocale(this.profileData.date_of_birth));
        return this._formBuilder.group({
            first_name: [{ value: this.profileData.first_name, disabled: false }, [Validators.required, this.noWhitespaceValidator]],
            last_name: [{ value: this.profileData.last_name, disabled: false }, [Validators.required, this.noWhitespaceValidator]],
            // title: [this.profileData.title],
            email: [{ value: this.profileData.email, disabled: true }, [Validators.email]],
            phone_number: [{ value: this.profileData.phone_number, disabled: false }, [Validators.required, Validators.minLength(10), Validators.pattern(/^([+-]?[1-9]\d*|0)$/)]],
            date_of_birth: [{ value: this.profileData.date_of_birth || null, disabled: false }, []],
            identity_number: [this.profileData.identity_number || null],
            declared_address: [this.profileData.declared_address || null],
            residence_address: [this.profileData.residence_address || null],
            declared_city_id: [this.profileData.declared_city_id || null],
            declaredCityName: [this.profileData.declaredCityName || ''],
            residence_city_id: [this.profileData.residence_city_id || null],
            residenceCityName: [this.profileData.residenceCityName || ''],
            // address: [this.profileData.address || ''],
            parent_first_name: [this.profileData.parent_first_name || ''],
            phone_number_fix: [this.profileData.phone_number_fix || ''],
            email2: [{ value: this.profileData.email2, disabled: false }, [Validators.email]],
            doctor: [this.profileData.doctor || ''],
            bank_account_number: [this.profileData.bank_account_number || '']
        });
    };
    ProfileComponent.prototype.noWhitespaceValidator = function (control) {
        var value = (control.value || '').toString();
        var isWhitespace = (value.trim()).length === 0;
        var isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    };
    ProfileComponent.prototype.createAdditionalProfileForm = function () {
        return this._formBuilder.group({});
    };
    ProfileComponent.prototype.setupUploaderOptions = function () {
        this.uploadOptionsProfileImage = {
            url: this._fuseConfig.api.url + '/portal/asset/add',
            multiple: false,
            accept: 'image/jpeg, image/png',
            maxFileSize: 3145728,
            collection: 'profile',
            iconButton: true,
            buttonTitle: this._translate.instant('Upload')
        };
    };
    ProfileComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getMultipleTranslationCategories(_this.lang, _this.categories);
            _this.dateAdapter.setLocale(_this.lang);
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    ProfileComponent.prototype.addDefaultValueToFilters = function () {
        // Default filter name translations can be done here
        this.filterCountry = tslib_1.__assign({}, this.defaultFilters['country'], { 0: this._translate.instant('all') });
        this.filterCity = tslib_1.__assign({}, this.defaultFilters['city'], { 0: this._translate.instant('all') });
        this.filterEmploy = tslib_1.__assign({}, this.defaultFilters['employ'], { 0: this._translate.instant('all') });
        this.filterPosition = tslib_1.__assign({}, this.defaultFilters['position'], { 0: this._translate.instant('all') });
    };
    ProfileComponent.prototype.updateDataDateFormat = function (data) {
        var _this = this;
        console.log(data);
        data.forEach(function (element) {
            var d = new Date(element.updated || element.updated_at);
            var datestring = moment(d);
            element.updated = datestring.locale(_this.lang).format('L');
        });
    };
    Object.defineProperty(ProfileComponent.prototype, "f", {
        // -----------------------------------------------------------------------------------------------------
        // @ Public methods
        // -----------------------------------------------------------------------------------------------------
        // convenience getter for easy access to form fields
        get: function () { return this.basicProfileForm.controls; },
        enumerable: true,
        configurable: true
    });
    ProfileComponent.prototype.dateLocale = function (date) {
        var datestring = moment(date);
        return datestring.locale(this.lang).format('L');
    };
    ProfileComponent.prototype.getMemberProfile = function () {
        var _this = this;
        this._profileService.getProfile()
            .then(function (response) {
            if (response.data) {
                _this.profileData = response.data;
                _this.getMemberProfileImage();
            }
        });
    };
    ProfileComponent.prototype.getMemberProfileImage = function () {
        var _this = this;
        this._profileService.getMemberProfileImage()
            .then(function (response) {
            _this.createImageFromBlob(response);
        });
    };
    ProfileComponent.prototype.getMemberProjects = function () {
        var _this = this;
        this._profileService.listUserProjects()
            .then(function (response) {
            if (response.data) {
                _this.projectsData = response.data;
            }
        });
    };
    ProfileComponent.prototype.getCity = function (str) {
        var cityData = str ? str.split(',') : [];
        var city = '';
        if (cityData.length > 0) {
            city = cityData[0].trim() + ', ' + cityData[cityData.length - 1].trim();
            city = city === ', ' ? '' : city;
        }
        return city;
    };
    ProfileComponent.prototype.toggleBasicDataEdit = function (isCancel) {
        this.basicDataNoEdit = !this.basicDataNoEdit;
        if (isCancel) {
            this.profileData = this.rawProfile;
            this.basicProfileForm = this.createBasicProfileForm();
        }
    };
    ProfileComponent.prototype.toggleAdditionalDataEdit = function (isCancel) {
        this.additionalDataNoEdit = !this.additionalDataNoEdit;
        if (isCancel) {
            this.formatDemogValues(this.rawDemogs);
        }
    };
    ProfileComponent.prototype.togglePasswordDataEdit = function (isCancel) {
        this.passwordDataNoEdit = !this.passwordDataNoEdit;
        if (isCancel) {
            this.memberPasswordForm = this.createPasswordForm();
            this.memberFirstPasswordForm = this.createFirstPasswordForm();
        }
    };
    ProfileComponent.prototype.savePassword = function (password) {
        var _this = this;
        console.log(password.getRawValue());
        if (!password.getRawValue().hasOwnProperty('oldPassword')) {
            console.log('Create password');
            this._profileService.createMyPassword(password.getRawValue())
                .then(function (x) {
                // Show the success message
                _this._matSnackBar.open(_this._translate.instant('Your password is created successfully.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
                _this.togglePasswordDataEdit(true);
                _this.getMemberProfile();
            }, function (err) {
                console.log(err);
            });
        }
        else {
            console.log('Edit password');
            this._profileService.editMyPassword(password.getRawValue())
                .then(function (x) {
                // Show the success message
                _this._matSnackBar.open(_this._translate.instant('Your password is changed successfully.'), '', {
                    verticalPosition: 'top',
                    horizontalPosition: 'right',
                    duration: 2000
                });
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
                _this.togglePasswordDataEdit(true);
            }, function (err) {
                var validationErrors = err.error;
                var formControl = _this.memberPasswordForm.get('oldPassword');
                if (formControl) {
                    // activate the error message
                    formControl.setErrors({
                        serverError: validationErrors.error
                    });
                    console.log(validationErrors.error);
                }
            });
        }
    };
    ProfileComponent.prototype.saveBasicProfile = function (member) {
        var _this = this;
        var e_1, _a;
        var data = member.getRawValue();
        if (moment.isMoment(data.date_of_birth)) {
            data.date_of_birth = data.date_of_birth.format('YYYY-MM-DD');
        }
        try {
            // do not send null fields
            for (var _b = tslib_1.__values(Object.entries(data)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = tslib_1.__read(_c.value, 2), key = _d[0], value = _d[1];
                if (value === null) {
                    delete data[key];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        data.residence_city_id = this.residenceSiteIdSelected ? this.residenceSiteIdSelected : data.residence_city_id || 0;
        data.declared_city_id = this.declaredSiteIdSelected ? this.declaredSiteIdSelected : data.declared_city_id || 0;
        this._profileService.updateProfile(data)
            .then(function (x) {
            // Show the success message
            _this._matSnackBar.open(_this._translate.instant('Profile data successfully updated.'), '', {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 2000
            });
            _this.basicDataNoEdit = true;
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function (x) { }, function (err) {
            var e_2, _a;
            var validationErrors = err.error;
            try {
                for (var _b = tslib_1.__values(Object.keys(validationErrors)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    var formControl = _this.basicProfileForm.get(key);
                    if (formControl) {
                        console.log(validationErrors);
                        formControl.setErrors({
                            serverError: validationErrors[key][0]
                        });
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
    };
    ProfileComponent.prototype.checkServerError = function (form, fieldName) {
        return form.get(fieldName).errors ? form.get(fieldName).errors.serverError ?
            form.get(fieldName).errors.serverError : 'This field is required!' : false;
    };
    ProfileComponent.prototype.saveAdditionalProfile = function (addData) {
        var data = addData.getRawValue();
        var uniqueIds = [];
        var colectChekboxes = {};
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var isCheckbox = false;
                var CheckboxOptionId = 0;
                var type = key.replace('ms', '');
                type = type.replace(/\d+/g, ''); // remove numbers
                var id = key.substr(0, key.indexOf('ms'));
                if (id === '') {
                    id = (key.match(/\d+/g).map(Number)).toString();
                }
                else {
                    isCheckbox = true;
                    id = (id.match(/\d+/g).map(Number)).toString();
                    CheckboxOptionId = parseInt(id, 10);
                }
                if (uniqueIds.indexOf(id) < 0) {
                    uniqueIds.push(id);
                    if (isCheckbox) {
                        colectChekboxes[id] = [];
                    }
                }
                if (type !== 'enum') {
                    if (data[key]) {
                        if (key.indexOf('date') > -1 && moment.isMoment(data[key])) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key].format('YYYY-MM-DD'));
                        }
                        else {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key]);
                        }
                    }
                }
                else {
                    if (!isCheckbox) {
                        if (data[key]) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), [data[key]]);
                        }
                    }
                    else {
                        if (data[key] && data[key].length > 0) {
                            this._profileService.updateProfileDemog(parseInt(id, 10), data[key]);
                        }
                    }
                }
            }
        }
        // Show the success message
        this._matSnackBar.open(this._translate.instant('Profile data successfully updated.'), '', {
            verticalPosition: 'top',
            horizontalPosition: 'right',
            duration: 2000
        });
        this.additionalDataNoEdit = true;
    };
    ProfileComponent.prototype.detachSocial = function (source) {
        var _this = this;
        console.log(source);
        this._profileService.detachFromSocial()
            .then(function (x) {
            // Show the success message
            _this._matSnackBar.open(_this._translate.instant('Profile detached from social network.'), '', {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 2000
            });
            _this.basicDataNoEdit = true;
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function (x) { }, function (err) {
            console.log(err);
        });
    };
    ProfileComponent.prototype.attachSocial = function (source) {
        var _this = this;
        console.log(source);
        this._authService.authenticateSocial(source, false);
        console.log('authenticateSocial called.');
        this._authService.socialLoginResponse
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (result) {
            console.log('authenticateSocial result:');
            console.log(result);
            _this._profileService.attachToSocial(result.authToken, source)
                .then(function (response) {
                console.log('Success!');
            }, function (err) {
                console.log('Error!', err.error);
                if (err.error.token && err.error.token.length) {
                    // Show the error message
                    _this._matSnackBar.open(_this._translate.instant(err.error.token[0]), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 3000
                    });
                }
            });
        });
    };
    ProfileComponent.prototype.getIdByOption = function (object, value) {
        var retVal = 0;
        object.forEach(function (element) {
            if (element.option === value) {
                retVal = element.id;
            }
        });
        return retVal;
    };
    ProfileComponent.prototype.formatDemogValues = function (data) {
        var _this = this;
        this.profileDemogs = [];
        this.additionalProfileForm = this.createAdditionalProfileForm();
        data.forEach(function (element) {
            if (element.type === 'enum') {
                _this._profileService.getEnumOptions(element.id)
                    .then(function (response) {
                    if (response.data) {
                        element.source = response.data;
                    }
                    if (element.multi_select) {
                        var defaultMultiselectValue_1 = [];
                        element.source.forEach(function (item) {
                            defaultMultiselectValue_1.push(_this.getIdByOption(element.value, item.option));
                        });
                        _this.additionalProfileForm.addControl(element.type + element.id + 'ms', new FormControl(defaultMultiselectValue_1));
                    }
                    else {
                        _this.additionalProfileForm.addControl(element.type + element.id, new FormControl(element.value[0] ? element.value[0].id : null));
                    }
                    _this.checkCustomDemogs(element.name);
                });
            }
            else {
                _this.additionalProfileForm.addControl(element.type + element.id, new FormControl(element.value));
            }
            _this.profileDemogs.push(element);
        });
    };
    ProfileComponent.prototype.deleteAsset = function (id, collection) {
        var _this = this;
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });
        this.confirmDialogRef.componentInstance.confirmMessage = this._translate.instant('Are you sure you want to delete the file?');
        if (collection !== 'cv') {
            this.confirmDialogRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this._profileService.deleteMemberAsset(id, collection)
                        .then(function (x) {
                        // Show the success message
                        _this._matSnackBar.open(_this._translate.instant('File deleted successfully.'), '', {
                            verticalPosition: 'top',
                            horizontalPosition: 'right',
                            duration: 2000
                        });
                    })
                        .catch(function (err) { return Promise.reject(err); })
                        .then(function (x) { }, function (err) {
                        console.log('Error:', err);
                        // Show the error message
                        _this._matSnackBar.open(_this._translate.instant('The file cannot be deleted.'), '', {
                            verticalPosition: 'top',
                            horizontalPosition: 'right',
                            duration: 2000
                        });
                    });
                }
                _this.confirmDialogRef = null;
            });
        }
        else {
            this.confirmDialogRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this._profileService.deleteMemberCv(id, collection)
                        .then(function (x) {
                        // Show the success message
                        _this._matSnackBar.open(_this._translate.instant('CV successfully deleted.'), '', {
                            verticalPosition: 'top',
                            horizontalPosition: 'right',
                            duration: 2000
                        });
                    })
                        .catch(function (err) { return Promise.reject(err); })
                        .then(function (x) { }, function (err) {
                        console.log('Error:', err);
                        // Show the error message
                        _this._matSnackBar.open(_this._translate.instant('CV cannot be deleted.'), '', {
                            verticalPosition: 'top',
                            horizontalPosition: 'right',
                            duration: 2000
                        });
                    });
                }
                _this.confirmDialogRef = null;
            });
        }
    };
    ProfileComponent.prototype.downloadAsset = function (id, collection, fileName) {
        this._profileService.downloadMemberAsset(id, collection, fileName);
    };
    ProfileComponent.prototype.downloadCv = function (fileName) {
        this._profileService.downloadMemberCv(fileName);
    };
    ProfileComponent.prototype.updateDataIcons = function (data) {
        var icon = '';
        data.forEach(function (element) {
            switch (element.type) {
                case 'image/jpeg':
                    icon = 'photo';
                    break;
                case 'image/png':
                    icon = 'photo';
                    break;
                case 'application/pdf':
                    icon = 'insert_drive_file';
                    break;
                case 'application/msword':
                    icon = 'insert_drive_file';
                    break;
                default:
                    icon = 'insert_drive_file';
                    break;
            }
            element.icon = icon;
        });
    };
    ProfileComponent.prototype.deleteProfile = function () {
        var _this = this;
        console.log('Delete profile');
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });
        this.confirmDialogRef.componentInstance.confirmMessage = this._translate.instant('Are you sure you want to delete your profile?');
        this.confirmDialogRef.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (result) {
            if (result) {
                _this._profileService.depersonalizer()
                    .then(function (x) {
                    // Show the success message
                    _this._matSnackBar.open(_this._translate.instant('Your profile has been deleted successfully.'), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 2000
                    });
                    _this._authService.logout();
                    _this._router.navigate(['/home']);
                })
                    .catch(function (err) { return Promise.reject(err); })
                    .then(function (x) { }, function (err) {
                    console.log('Error:', err);
                    // Show the error message
                    _this._matSnackBar.open(_this._translate.instant('Your profile cannot be deleted.'), '', {
                        verticalPosition: 'top',
                        horizontalPosition: 'right',
                        duration: 2000
                    });
                });
            }
            _this.confirmDialogRef = null;
        });
    };
    ProfileComponent.prototype.removeMemberSkill = function (chip, group) {
        this._profileService.removeSkillFromMember(chip.id, group);
    };
    // assignSkillToMember(group): void {
    //     this.dialogRef = this._matDialog.open(MemberSkillFormDialogComponent, {
    //         panelClass: 'skill-form-dialog',
    //         data: {
    //             group: group,
    //             memberSkills: this.memberSkills[group],
    //             action: 'new'
    //         }
    //     });
    //     this.dialogRef.afterClosed()
    //         .subscribe(response => {
    //             if (!response) {
    //                 return;
    //             }
    //             const actionType: string = response[0];
    //             const formData: FormGroup = response[1];
    //             switch (actionType) {
    //                 /**
    //                  * Save
    //                  */
    //                 case 'save':
    //                     // this._memberManagementService.updateMember(formData.getRawValue());
    //                     break;
    //                 /**
    //                  * Delete
    //                  */
    //                 case 'delete':
    //                     // this.deleteMember(member);
    //                     break;
    //             }
    //         });
    // }
    ProfileComponent.prototype.declaredSiteOnChange = function (site) {
        this.declaredSiteIdSelected = site.osm_id;
        this.basicProfileForm.controls['declaredCityName'].setValue(site.display_name);
        this.basicProfileForm.markAsDirty();
    };
    ProfileComponent.prototype.resitenceSiteOnChange = function (site) {
        this.residenceSiteIdSelected = site.osm_id;
        this.basicProfileForm.controls['residenceCityName'].setValue(site.display_name);
        this.basicProfileForm.markAsDirty();
    };
    ProfileComponent.prototype.getValidGenders = function () {
        var _this = this;
        this._profileService.getValidGendersOfMemberChildren()
            .then(function (response) {
            console.log(response.data);
            if (response.data) {
                _this.genderData = response.data;
            }
            else {
                _this.genderData.length = 0;
            }
        });
    };
    ProfileComponent.prototype.getValidLanguages = function () {
        var _this = this;
        this._profileService.getValidLangsOfSpokenLanguage()
            .then(function (response) {
            console.log(response.data);
            if (response.data) {
                _this.languageData = response.data;
            }
            else {
                _this.languageData.length = 0;
            }
        });
    };
    ProfileComponent.prototype.getValidLevels = function () {
        var _this = this;
        this._profileService.getValidLevelsOfSpokenLanguage()
            .then(function (response) {
            console.log(response.data);
            if (response.data) {
                _this.levelData = [];
                Object.keys(response.data).forEach(function (item) {
                    _this.levelData.push({ value: item, name: response.data[item] });
                });
                console.log(_this.levelData);
                _this.levelDataObj = response.data;
            }
            else {
                _this.levelData.length = 0;
                _this.levelDataObj = {};
            }
        });
    };
    ProfileComponent.prototype.checkCustomDemogs = function (name) {
        if (name === 'Member Children') {
            this.getChildrenData();
        }
        if (name === 'Member Spoken Language') {
            this.getSpokenData();
        }
        if (name === 'Member Work Experience') {
            this.getExperienceData();
        }
        if (name === 'Member Education') {
            this.getEducationData();
        }
    };
    ProfileComponent.prototype.getChildrenData = function () {
        this._profileService.listMemberChildren();
    };
    ProfileComponent.prototype.getSpokenData = function () {
        this._profileService.listMemberSpokenLanguages();
    };
    ProfileComponent.prototype.getExperienceData = function () {
        this._profileService.listMemberWorkExperience();
    };
    ProfileComponent.prototype.getEducationData = function () {
        this._profileService.listMemberEducation();
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    ProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this._authService.isAuthenticated()) {
            this.loggedIn = false;
            this._router.navigate(['/login']);
        }
        else {
            this.loggedIn = true;
            this.getMemberProfile();
            this.getMemberProjects();
            console.log(this._authService.userInfo);
            if (this._authService.userInfo) {
                this.gdprFlag = parseInt(this._authService.userInfo['gdpr_flag'], 10);
            }
        }
        this.setupUploaderOptions();
        // recheck for gdpr flag
        this._authService.userSetComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (_this._authService.userInfo) {
                _this.gdprFlag = parseInt(_this._authService.userInfo['gdpr_flag'], 10);
            }
        });
        this._authService.logoutComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.loggedIn = false;
            // this._router.navigate(['/home']);
        });
        this._profileService.onMemberImageChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.createImageFromBlob(response);
        }, function (err) {
        });
        this._profileService.onProfileChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (response.data) {
                _this.profileData = response.data;
                _this.rawProfile = _this.profileData;
                _this.basicProfileForm = _this.createBasicProfileForm();
            }
        }, function (err) {
        });
        this._profileService.onMemberFilesChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            console.log(response);
            _this.docFiles = response.data;
            _this.updateDataIcons(_this.docFiles);
            // this.updateDataDateFormat(this.docFiles);
        }, function (err) {
        });
        this._profileService.getAllCitiesList()
            .then(function (response) {
            if (response) {
                _this.cities = _.orderBy(response, 'city', 'asc');
                console.log(_this.cities);
            }
        });
        this._profileService.onMemberCvChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            console.log(response);
            _this.cvFile = response;
            _this.cvFile.name = _this.cvFile.name ? _this.cvFile.name.split('.').slice(0, -1).join('.') : '';
            _this.updateDataIcons([_this.cvFile]);
            // this.updateDataDateFormat([this.cvFile]);
        }, function (err) {
        });
        // Notifications related
        this._notificationsService.listAllNotifications();
        this._notificationsService.onNotificationsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (newNotificationCount) {
            _this.unreadedNotifications = '';
            if (newNotificationCount > 0) {
                _this.unreadedNotifications = newNotificationCount.toString();
                // Update project statuses
                _this.getMemberProjects();
            }
        });
        if (this._notificationsService.fromNotifications) {
            this.activeTabIndex = 4;
            this._notificationsService.fromNotifications = false;
        }
        // Demogs related
        this._profileService.onProfileDemogsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.profileDemogs = [];
            if (response.data) {
                _this.rawDemogs = response.data;
                _this.formatDemogValues(response.data);
                console.log(_this.profileDemogs);
            }
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
        this._translationLoader.pageTranslationsLoaded
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () {
            _this.addDefaultValueToFilters();
            setTimeout(function () {
                _this.setupUploaderOptions();
            }, 900);
        });
        // Skills related
        this._profileService.getSkillGroups()
            .then(function (response) {
            _this.skillGroups = response;
            _this.skillGroups.forEach(function (group) {
                _this._profileService.getSkills(group)
                    .then(function (skills) {
                    _this.allSkills[group] = skills;
                });
                _this._profileService.getSkills(group)
                    .then(function (memberSkills) {
                    _this.memberSkills[group] = memberSkills;
                });
            });
        });
        this._profileService.onMemberSkillsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (response.group) {
                _this.memberSkills[response.group] = response.data;
            }
        });
        this._uploadService.onFileUploaded
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this._profileService.getMemberProfileImage();
        }, function (err) {
        });
        this._profileService.onMemberChildrenChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            console.log(response);
            if (response.data) {
                _this.customDemogDataChild = response.data;
            }
            else {
                _this.customDemogDataChild.length = 0;
            }
        });
        this._profileService.onMemberLanguageChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (response.data) {
                _this.customDemogDataLang = response.data;
            }
            else {
                _this.customDemogDataLang.length = 0;
            }
        });
        this._profileService.onMemberWorkExperienceChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (response.data) {
                console.log(response.data);
                _this.customDemogDataExperience = response.data;
            }
            else {
                _this.customDemogDataExperience.length = 0;
            }
        });
        this._profileService.onMemberEducationChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (response.data) {
                console.log(response.data);
                _this.customDemogDataEducation = response.data;
            }
            else {
                _this.customDemogDataEducation.length = 0;
            }
        });
        this.getValidGenders();
        this.getValidLanguages();
        this.getValidLevels();
    };
    ProfileComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return ProfileComponent;
}());
export { ProfileComponent };
var MyErrorStateMatcher = /** @class */ (function () {
    function MyErrorStateMatcher() {
    }
    MyErrorStateMatcher.prototype.isErrorState = function (control, form) {
        var invalidCtrl = !!(control && control.invalid && control.parent.dirty);
        var invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);
        return (invalidCtrl || invalidParent);
    };
    return MyErrorStateMatcher;
}());
export { MyErrorStateMatcher };
var PasswordValidation = /** @class */ (function () {
    function PasswordValidation() {
    }
    PasswordValidation.MatchPassword = function (AC) {
        var password = AC.parent ? AC.parent.get('password').value : '';
        var passwordConfirm = AC.value;
        if (password !== '' && password !== passwordConfirm) {
            AC.setErrors({ MatchPassword: true });
            return { passwordsNotMatching: true };
        }
        else {
            return null;
        }
    };
    PasswordValidation.WeakPassword = function (AC) {
        var password = AC.value; // to get value in input tag
        if (password.length && (password.length < 8 || !password.match(/\d/)
            || password.toLowerCase() === password || password.toUpperCase() === password)) {
            AC.setErrors({ WeakPassword: true });
            return { passwordWeak: true };
        }
        else {
            return null;
        }
    };
    return PasswordValidation;
}());
export { PasswordValidation };
